module.exports = __webpack_public_path__ + "static/media/flecha_arriba.8b670ce9.svg";